

export default {
  locale: 'pt-br',
  Pagination: {
    items_per_page: '/ página',
    jump_to: 'Vá até',
    jump_to_confirm: 'confirme',
    page: 'Página',
    prev_page: 'Página anterior',
    next_page: 'Próxima página',
    prev_5: '5 páginas anteriores',
    next_5: '5 próximas páginas',
    prev_3: '3 páginas anteriores',
    next_3: '3 próximas páginas',
    page_size: 'tamanho da página'
  },
  DatePicker: {
    lang: {
      placeholder: 'Selecionar data',
      yearPlaceholder: 'Selecionar ano',
      quarterPlaceholder: 'Selecionar trimestre',
      monthPlaceholder: 'Selecionar mês',
      weekPlaceholder: 'Selecionar semana',
      rangePlaceholder: ['Data inicial', 'Data final'],
      rangeYearPlaceholder: ['Ano inicial', 'Ano Final'],
      rangeMonthPlaceholder: ['Mês inicial', 'Mês final'],
      rangeWeekPlaceholder: ['Semana inicial', 'Semana final'],
      locale: 'pt_BR',
      today: 'Hoje',
      now: 'Agora',
      backToToday: 'Voltar para hoje',
      ok: 'Ok',
      clear: 'Limpar',
      month: 'Mês',
      year: 'Ano',
      timeSelect: 'Selecionar hora',
      dateSelect: 'Selecionar data',
      weekSelect: 'Escolher semana',
      monthSelect: 'Escolher mês',
      yearSelect: 'Escolher ano',
      decadeSelect: 'Escolher década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: false,
      previousMonth: 'Mês anterior (PageUp)',
      nextMonth: 'Próximo mês (PageDown)',
      previousYear: 'Ano anterior (Control + esquerda)',
      nextYear: 'Próximo ano (Control + direita)',
      previousDecade: 'Década anterior',
      nextDecade: 'Próxima década',
      previousCentury: 'Século anterior',
      nextCentury: 'Próximo século',
      shortWeekDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    },
    timePickerLocale: {
      placeholder: 'Hora',
      rangePlaceholder: ['Hora inicial', 'Hora final']
    }
  },
  TimePicker: {
    placeholder: 'Hora',
    rangePlaceholder: ['Hora inicial', 'Hora final']
  },
  Calendar: {
    lang: {
      placeholder: 'Selecionar data',
      yearPlaceholder: 'Selecionar ano',
      quarterPlaceholder: 'Selecionar trimestre',
      monthPlaceholder: 'Selecionar mês',
      weekPlaceholder: 'Selecionar semana',
      rangePlaceholder: ['Data inicial', 'Data final'],
      rangeYearPlaceholder: ['Ano inicial', 'Ano Final'],
      rangeMonthPlaceholder: ['Mês inicial', 'Mês final'],
      rangeWeekPlaceholder: ['Semana inicial', 'Semana final'],
      locale: 'pt_BR',
      today: 'Hoje',
      now: 'Agora',
      backToToday: 'Voltar para hoje',
      ok: 'Ok',
      clear: 'Limpar',
      month: 'Mês',
      year: 'Ano',
      timeSelect: 'Selecionar hora',
      dateSelect: 'Selecionar data',
      weekSelect: 'Escolher semana',
      monthSelect: 'Escolher mês',
      yearSelect: 'Escolher ano',
      decadeSelect: 'Escolher década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: false,
      previousMonth: 'Mês anterior (PageUp)',
      nextMonth: 'Próximo mês (PageDown)',
      previousYear: 'Ano anterior (Control + esquerda)',
      nextYear: 'Próximo ano (Control + direita)',
      previousDecade: 'Década anterior',
      nextDecade: 'Próxima década',
      previousCentury: 'Século anterior',
      nextCentury: 'Próximo século',
      shortWeekDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    },
    timePickerLocale: {
      placeholder: 'Hora',
      rangePlaceholder: ['Hora inicial', 'Hora final']
    }
  },
  global: {
    placeholder: 'Por favor escolha'
  },
  Table: {
    filterTitle: 'Menu de Filtro',
    filterConfirm: 'OK',
    filterReset: 'Resetar',
    filterEmptyText: 'Sem filtros',
    emptyText: 'Sem conteúdo',
    selectAll: 'Selecionar página atual',
    selectInvert: 'Inverter seleção',
    selectionAll: 'Selecionar todo o conteúdo',
    sortTitle: 'Ordenar título',
    expand: 'Expandir linha',
    collapse: 'Colapsar linha',
    triggerDesc: 'Clique organiza por descendente',
    triggerAsc: 'Clique organiza por ascendente',
    cancelSort: 'Clique para cancelar organização',
    selectNone: 'Apagar todo o conteúdo'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancelar',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancelar'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Procurar',
    itemUnit: 'item',
    itemsUnit: 'items',
    remove: 'Remover',
    selectCurrent: 'Selecionar página atual',
    removeCurrent: 'Remover página atual',
    selectAll: 'Selecionar todos',
    removeAll: 'Remover todos',
    selectInvert: 'Inverter seleção atual'
  },
  Upload: {
    uploading: 'Enviando...',
    removeFile: 'Remover arquivo',
    uploadError: 'Erro no envio',
    previewFile: 'Visualizar arquivo',
    downloadFile: 'Baixar arquivo'
  },
  Empty: {
    description: 'Não há dados'
  },
  Icon: {
    icon: 'ícone'
  },
  Text: {
    edit: 'editar',
    copy: 'copiar',
    copied: 'copiado',
    expand: 'expandir'
  },
  PageHeader: {
    back: 'Retornar'
  },
  Image: {
    preview: 'Pré-visualização'
  }
};
